// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Vector Lines.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

.beginner_wrapper {
  scroll-snap-type: y mandatory;
  overflow-y: scroll;
  height: 100%;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.beginner-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.beginner-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #f4f4f4;
  /* height: 100vh; */
  padding: 3rem 0;
  width: 100%;
  margin: 0 auto 0;
}

.beginner-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #f4f4f4;
  /* height: 100vh; */
  /* Module Grid Layout Styles */
}

.modules-grid-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 1rem 0;
}

.module-card {
  background: #1a1a1a;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.module-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.1);
}

.module-header h3 {
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.module-content p {
  color: #f4f4f4;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.module-buttons {
  display: flex;
  justify-content: flex-start;
}

.module-btn {
  background: #ff6b35;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.module-btn:hover {
  background: #e55a2b;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modules-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .module-card {
    padding: 1.25rem;
  }
  
  .module-header h3 {
    font-size: 1.1rem;
  }
}

#scroll_display {
  display: flex;
}

.back_home {
  position: absolute;
  top: 16%;
  left: 10%;
  display: flex;
  justify-items: center;
  align-items: center;
}

.beginner-content h1 {
  margin-top: 12rem;
  font-family: Eczar;
  font-size: 56px;
  font-weight: 600;
  line-height: 100px;
  letter-spacing: 0em;
  text-align: center;
  background: transparent;
}

.beginner-content p {
  font-size: 18px;
  max-width: 70%;
  margin: 0 auto;
  background: #15141d;
  font-family: inter;
  word-spacing: 1px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  color: #b3b3b3;
  /* overflow: hidden; */
}

.reserve-btns button {
  height: 48px;
  font-size: 16px;
  font-family: inter;
  font-weight: 500;
  border-radius: 64px;
  border: solid 1px rgba(255, 223, 188, 1);
  justify-content: center;
  gap: 10px;
  padding: 0;
  width: 192px;
  background-color: rgba(251, 133, 0, 1);
}

.beginners_mentors_container {
  gap: 40px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 40px auto;
  justify-content: space-around;
  align-items: center;
}

.beginners_mentor_wraps {
  transition: 0.9s;
  gap: 20px;
  background-color: transparent;
  width: 30%;
}

.beginners_mentor_wraps:hover {
  transform: scale(1.01);
  box-shadow: 0 0 30px -10px rgba(8, 8, 6, 0.25);
}

.beginners_mentor_images {
  text-align: center;
  color: azure;
  background-color: rgba(28, 27, 38, 1);
  border-radius: 16px 16px 0 0;
  width: 100%;
}

.beginner_wrapper .mentors {
  color: #b3b3b3;
  border-radius: 16px;
  height: 70%;
  width: 80%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 72px auto 0;
}

.beginners_mentors_text {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 120px;
}

.mentors_container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.beginners_mentors_text h1 {
  font-family: Eczar;
  color: #fff;
  font-size: 48px;
  margin: 0;
}

.beginners_mentors_text p {
  background: rgba(21, 20, 29, 1);
}

.beginners_mentors_text .oranges {
  font-size: 48px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.beginners_mentor_wraps .mentor_image_wrap {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.mentor_wrap {
  width: 24%;
  transition: 1.5s;
}

.mentor_wrap:hover {
  transform: scale(1.05);
  box-shadow: 0 0 40px -10px rgba(8, 8, 6, 0.25);
}

.mentor_images {
  text-align: center;
  color: azure;
  background-color: rgba(28, 27, 38, 1);
}

.beginners_mentor_wraps .mentor_para {
  background: rgba(21, 20, 29, 1);
  justify-content: center;
  text-align: center;
}

.mentor_para h3 {
  align-items: center;
  font-family: Eczar;
  font-size: 16px;
  margin: 6px auto;
}

.mentor_para p {
  text-align: center;
  font-size: 14px;
  background: rgba(21, 20, 29, 1);
}

.beginners_mentor_images {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  display: block;
  margin: 0 auto;
}

.mentor_para {
  color: #b3b3b3;
  display: block;
  text-align: center;
  border: none;
  text-align: left;
  margin: 0.4rem;
  background-color: rgba(28, 27, 38, 1);
}

.faq_mentors_text h1 {
  font-size: 48px;
  font-family: Eczar;
  color: #fff;
  margin: 0 auto 0;
  width: 100%;
  margin: 0 auto 0;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.faq_mentors_text .oranges {
  font-size: 48px;
  line-height: 70px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.faq_container {
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 6px;
}

.faq_mentext .accordion {
  color: #b3b3b3;
}

.reserve-btn button {
  font-size: 20px;
}

.accordion_one {
  margin: 0 auto;
  height: 65%;
}

.accordion_one p {
  color: #b3b3b3;
}

.accordion_three {
  font-size: 24px;
  padding-left: 16px;
  padding-top: 12px;
}

.accordion_four {
  padding-left: 16px;
  padding-bottom: 16px;
}

.accordion_buttons {
  background-color: #1c1b26;
  margin-top: 16px;
  padding-bottom: 12px;
}

.accordion_buttons button.even {
  border-radius: 4px;
  border: 1px solid #ffb703;
  background: #fb8500;
  display: inline-flex;
  padding: 4px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #f3ece5;
  height: 30px;
}

.accordion_buttons button.odd {
  border-radius: 4px;
  border: 1px solid #8ecae6;
  background: #219ebc;
  display: inline-flex;
  padding: 4px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #f3ece5;
  height: 30px;
  margin-bottom: 5px;
}

.button_gap {
  margin-right: 10px;
}

.begtrack_text h1 {
  background-color: darkorange;
}

.item {
  border: 3px solid rgba(75, 75, 75, 0.25);
  height: auto;
  border-radius: 12px;
  background-color: rgba(28, 27, 38, 1);
  padding: 10px 10px;
  margin-bottom: 15px;
}

.item .title {
  margin-top: 1px;
}

.video_btn {
  background-color: rgba(251, 133, 0, 1);
  width: 160px;
  color: rgb(252, 252, 252);
  border-radius: 4px;
  border-style: none;
  display: flex;
  font-family: Eczar;
  font-size: 12px;
  font-weight: 300;
  padding: 10px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  height: 20px;
}

.head_wrap {
  padding-top: 16px;
  padding-bottom: 16px;
  margin: 0;
}

@media screen and (max-width: 768px) {
.beginner_wrapper{
  width: 90%;
}
  .beginner-content h1,
  .beginners_mentors_text h1,
  .oranges {
    font-size: 36px;
  }

  .beginners_mentor_wraps {
    flex: 1 1 100%;
    /* min-height: 200px; */
  }
}

/* Module Grid Layout Styles */
.modules-grid-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background: #0d1117;
}

.modules-grid {
  display: flex; /* Changed to flexbox */
  flex-wrap: wrap; /* Allows cards to wrap to the next line */
  gap: 2rem;
  padding: 1rem 0;
}

.module-card {
  background: #1a1a1a;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 300px; /* Ensures cards stretch to equal height */
}

.module-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.1);
}

.module-header h3 {
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.module-content p {
  color: #f4f4f4;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.module-buttons {
  display: flex;
  justify-content: flex-start;
}

.module-btn {
  background: #ff6b35;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-decoration: none;
}

.module-btn:hover {
  background: #e55a2b;
}

/* Responsive adjustments for module grid */
@media (max-width: 768px) {
  .modules-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .module-card {
    padding: 1.25rem;
  }
  
  .module-header h3 {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/BeginnersTrack.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAAkD;EAClD,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;AACX;;AAEA;AACA;EACE,UAAU;AACZ;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,eAAe,EAAE,0CAA0C;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\n.beginner_wrapper {\n  scroll-snap-type: y mandatory;\n  overflow-y: scroll;\n  height: 100%;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.beginner-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.beginner-content {\n  background-image: url(../images/Vector\\ Lines.png);\n  background-position: center;\n  background-size: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  color: #f4f4f4;\n  /* height: 100vh; */\n  padding: 3rem 0;\n  width: 100%;\n  margin: 0 auto 0;\n}\n\n.beginner-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  color: #f4f4f4;\n  /* height: 100vh; */\n  /* Module Grid Layout Styles */\n}\n\n.modules-grid-container {\n  padding: 2rem 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.modules-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  padding: 1rem 0;\n}\n\n.module-card {\n  background: #1a1a1a;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid #333;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.module-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.1);\n}\n\n.module-header h3 {\n  color: #ff6b35;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n}\n\n.module-content p {\n  color: #f4f4f4;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.module-buttons {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.module-btn {\n  background: #ff6b35;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.module-btn:hover {\n  background: #e55a2b;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .modules-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .module-card {\n    padding: 1.25rem;\n  }\n  \n  .module-header h3 {\n    font-size: 1.1rem;\n  }\n}\n\n#scroll_display {\n  display: flex;\n}\n\n.back_home {\n  position: absolute;\n  top: 16%;\n  left: 10%;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n}\n\n.beginner-content h1 {\n  margin-top: 12rem;\n  font-family: Eczar;\n  font-size: 56px;\n  font-weight: 600;\n  line-height: 100px;\n  letter-spacing: 0em;\n  text-align: center;\n  background: transparent;\n}\n\n.beginner-content p {\n  font-size: 18px;\n  max-width: 70%;\n  margin: 0 auto;\n  background: #15141d;\n  font-family: inter;\n  word-spacing: 1px;\n  font-weight: 400;\n  line-height: 32px;\n  text-align: center;\n  color: #b3b3b3;\n  /* overflow: hidden; */\n}\n\n.reserve-btns button {\n  height: 48px;\n  font-size: 16px;\n  font-family: inter;\n  font-weight: 500;\n  border-radius: 64px;\n  border: solid 1px rgba(255, 223, 188, 1);\n  justify-content: center;\n  gap: 10px;\n  padding: 0;\n  width: 192px;\n  background-color: rgba(251, 133, 0, 1);\n}\n\n.beginners_mentors_container {\n  gap: 40px;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 40px auto;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.beginners_mentor_wraps {\n  transition: 0.9s;\n  gap: 20px;\n  background-color: transparent;\n  width: 30%;\n}\n\n.beginners_mentor_wraps:hover {\n  transform: scale(1.01);\n  box-shadow: 0 0 30px -10px rgba(8, 8, 6, 0.25);\n}\n\n.beginners_mentor_images {\n  text-align: center;\n  color: azure;\n  background-color: rgba(28, 27, 38, 1);\n  border-radius: 16px 16px 0 0;\n  width: 100%;\n}\n\n.beginner_wrapper .mentors {\n  color: #b3b3b3;\n  border-radius: 16px;\n  height: 70%;\n  width: 80%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 72px auto 0;\n}\n\n.beginners_mentors_text {\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: 120px;\n}\n\n.mentors_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.beginners_mentors_text h1 {\n  font-family: Eczar;\n  color: #fff;\n  font-size: 48px;\n  margin: 0;\n}\n\n.beginners_mentors_text p {\n  background: rgba(21, 20, 29, 1);\n}\n\n.beginners_mentors_text .oranges {\n  font-size: 48px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.beginners_mentor_wraps .mentor_image_wrap {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.mentor_wrap {\n  width: 24%;\n  transition: 1.5s;\n}\n\n.mentor_wrap:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0 40px -10px rgba(8, 8, 6, 0.25);\n}\n\n.mentor_images {\n  text-align: center;\n  color: azure;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.beginners_mentor_wraps .mentor_para {\n  background: rgba(21, 20, 29, 1);\n  justify-content: center;\n  text-align: center;\n}\n\n.mentor_para h3 {\n  align-items: center;\n  font-family: Eczar;\n  font-size: 16px;\n  margin: 6px auto;\n}\n\n.mentor_para p {\n  text-align: center;\n  font-size: 14px;\n  background: rgba(21, 20, 29, 1);\n}\n\n.beginners_mentor_images {\n  width: 250px;\n  height: 250px;\n  border-radius: 50%;\n  object-fit: cover;\n  overflow: hidden;\n  display: block;\n  margin: 0 auto;\n}\n\n.mentor_para {\n  color: #b3b3b3;\n  display: block;\n  text-align: center;\n  border: none;\n  text-align: left;\n  margin: 0.4rem;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.faq_mentors_text h1 {\n  font-size: 48px;\n  font-family: Eczar;\n  color: #fff;\n  margin: 0 auto 0;\n  width: 100%;\n  margin: 0 auto 0;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.faq_mentors_text .oranges {\n  font-size: 48px;\n  line-height: 70px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.faq_container {\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  margin-top: 6px;\n}\n\n.faq_mentext .accordion {\n  color: #b3b3b3;\n}\n\n.reserve-btn button {\n  font-size: 20px;\n}\n\n.accordion_one {\n  margin: 0 auto;\n  height: 65%;\n}\n\n.accordion_one p {\n  color: #b3b3b3;\n}\n\n.accordion_three {\n  font-size: 24px;\n  padding-left: 16px;\n  padding-top: 12px;\n}\n\n.accordion_four {\n  padding-left: 16px;\n  padding-bottom: 16px;\n}\n\n.accordion_buttons {\n  background-color: #1c1b26;\n  margin-top: 16px;\n  padding-bottom: 12px;\n}\n\n.accordion_buttons button.even {\n  border-radius: 4px;\n  border: 1px solid #ffb703;\n  background: #fb8500;\n  display: inline-flex;\n  padding: 4px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  color: #f3ece5;\n  height: 30px;\n}\n\n.accordion_buttons button.odd {\n  border-radius: 4px;\n  border: 1px solid #8ecae6;\n  background: #219ebc;\n  display: inline-flex;\n  padding: 4px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  color: #f3ece5;\n  height: 30px;\n  margin-bottom: 5px;\n}\n\n.button_gap {\n  margin-right: 10px;\n}\n\n.begtrack_text h1 {\n  background-color: darkorange;\n}\n\n.item {\n  border: 3px solid rgba(75, 75, 75, 0.25);\n  height: auto;\n  border-radius: 12px;\n  background-color: rgba(28, 27, 38, 1);\n  padding: 10px 10px;\n  margin-bottom: 15px;\n}\n\n.item .title {\n  margin-top: 1px;\n}\n\n.video_btn {\n  background-color: rgba(251, 133, 0, 1);\n  width: 160px;\n  color: rgb(252, 252, 252);\n  border-radius: 4px;\n  border-style: none;\n  display: flex;\n  font-family: Eczar;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 10px 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n  height: 20px;\n}\n\n.head_wrap {\n  padding-top: 16px;\n  padding-bottom: 16px;\n  margin: 0;\n}\n\n@media screen and (max-width: 768px) {\n.beginner_wrapper{\n  width: 90%;\n}\n  .beginner-content h1,\n  .beginners_mentors_text h1,\n  .oranges {\n    font-size: 36px;\n  }\n\n  .beginners_mentor_wraps {\n    flex: 1 1 100%;\n    /* min-height: 200px; */\n  }\n}\n\n/* Module Grid Layout Styles */\n.modules-grid-container {\n  padding: 2rem 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: #0d1117;\n}\n\n.modules-grid {\n  display: flex; /* Changed to flexbox */\n  flex-wrap: wrap; /* Allows cards to wrap to the next line */\n  gap: 2rem;\n  padding: 1rem 0;\n}\n\n.module-card {\n  background: #1a1a1a;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid #333;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1 1 300px; /* Ensures cards stretch to equal height */\n}\n\n.module-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.1);\n}\n\n.module-header h3 {\n  color: #ff6b35;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n}\n\n.module-content p {\n  color: #f4f4f4;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.module-buttons {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.module-btn {\n  background: #ff6b35;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-decoration: none;\n}\n\n.module-btn:hover {\n  background: #e55a2b;\n}\n\n/* Responsive adjustments for module grid */\n@media (max-width: 768px) {\n  .modules-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .module-card {\n    padding: 1.25rem;\n  }\n  \n  .module-header h3 {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
